import { Box, Grid } from "@chakra-ui/react";
import { GetStaticProps } from "next";
import Head from "next/head";
import { useRouter } from "next/router";
import FlickrImage from "../../components/FlickrImage";
import FullPageCenteredSpinner from "../../components/FullPageCenteredSpinner";
import flickr from "../../services/flickr";

const templateColumns = [
  "repeat(1, 1fr)",
  "repeat(2, 1fr)",
  "repeat(3, 1fr)",
  "repeat(4, 1fr)",
];

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const response = await flickr.photosets.getPhotos({
      photoset_id: context.params.photoset_id,
      user_id: "79255126@N05",
    });
    if (!response || !response.ok || response.body.stat !== "ok") {
      throw new Error();
    }

    return {
      props: {
        ...response.body,
      },
      revalidate: 60 * 10,
    };
  } catch {
    return {
      redirect: {
        destination: "/",
        permanent: false,
      },
    };
  }
};

export default function Index({ photoset }: any) {
  const router = useRouter();

  if (router.isFallback) {
    return <FullPageCenteredSpinner />;
  }
  return (
    <>
      <Head>
        <title>Matthew Costabile | Photos | {photoset.title}</title>
      </Head>
      <Grid
        gridTemplateColumns={templateColumns}
        gap={10}
        textAlign="center"
        gridTemplateRows="masonry"
      >
        {photoset.photo.map((photo) => {
          if (photo.ispublic === 0) return null;
          return (
            <Grid
              key={photo.id}
              as="figure"
              gridTemplateRows="1fr auto"
              overflow="hidden"
            >
              <FlickrImage {...photo} alt={photo.title} />
              <Box
                as="figcaption"
                gridRow={2}
                gridColumn={1}
                padding="0.2em 0.5em"
                justifySelf="center"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {photo.title}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
